import { Loader } from '@pocketlaw/tetris';
import { LoadingContainer } from './styled';
function SectionLoader(props) {
    const { label } = props;
    return (<LoadingContainer>
      <Loader size={16} label={label}/>
    </LoadingContainer>);
}
export { SectionLoader as Loader };
